export enum ContactMethod {
    Phone = 1,
    Email = 2,
    Text = 3,
    Teams = 4
}
